import {
    Paper,
    Radio,
    RadioGroup,
    FormControlLabel,
    Typography,
} from "@mui/material";
import './select-object.scss';
import { AppEnum } from "../../../constants/app-enum";


const SelectObject = (props) => {

    const { selectedObjectUId, handleObjectSelection, collectionObjects, collectionType, handleCollectionTypeChange } = props;
    
    const renderData = (collectionObjects, itemsPerColumn) => {
        if (!collectionObjects || collectionObjects.length <= 0) {
            return null;
        }

        // Group the data by groupName and childGroupName
        const groupedData = collectionObjects.reduce((groups, item) => {
            const group = item.groupName || '';
            const subGroup = item.childGroupName || '';

            if (!groups[group]) {
                groups[group] = { subGroups: {}, items: [] };
            }

            if (subGroup) {
                if (!groups[group].subGroups[subGroup]) {
                    groups[group].subGroups[subGroup] = [];
                }
                groups[group].subGroups[subGroup].push(item);
            } else {
                groups[group].items.push(item);
            }

            return groups;
        }, {});

        const columns = [];
        let columnIndex = 0;

        Object.keys(groupedData).forEach((group, groupIndex) => {
            const { subGroups, items } = groupedData[group];
            let currentColumnItems = [];
            let itemCount = 0;

            // Add group label
            currentColumnItems.push(
                <div key={`${groupIndex}-group-label`}>
                    <div className="group-label-div">{group}</div>
                </div>
            );
            itemCount++;

            // Iterate over subgroups
            Object.keys(subGroups).forEach((subGroup, subGroupIndex) => {
                const subGroupItems = subGroups[subGroup];

                // Add subgroup label
                currentColumnItems.push(
                    <div key={`${groupIndex}-${subGroupIndex}-subgroup-label`} className="subgroup-label-div">
                        {subGroup}
                    </div>
                );
                itemCount++;

                // Add subgroup items
                subGroupItems.forEach((item, itemIndex) => {
                    currentColumnItems.push(
                        <div key={`${groupIndex}-${subGroupIndex}-${columnIndex}-${itemIndex}`} style={{ marginLeft: '20px' }}>
                            <FormControlLabel
                                value={item.templateCollectionId}
                                control={
                                    <Radio
                                        sx={{
                                            color: "#018786 !important",
                                            '&.Mui-checked': {
                                                color: "#018786 !important",
                                            },
                                        }}
                                    />
                                }
                                label={item.name}
                                sx={{
                                    color: `#6B859E !important`,
                                }}
                            />
                        </div>
                    );
                    itemCount++;
                });
            });

            // Add remaining group items (without subgroup)
            items.forEach((item, itemIndex) => {
                currentColumnItems.push(
                    <div key={`${groupIndex}-${columnIndex}-${itemIndex}`}>
                        <FormControlLabel
                            value={item.templateCollectionId}
                            control={
                                <Radio
                                    sx={{
                                        color: "#018786 !important",
                                        '&.Mui-checked': {
                                            color: "#018786 !important",
                                        },
                                    }}
                                />
                            }
                            label={item.name}
                            sx={{
                                color: `#6B859E !important`,
                            }}
                        />
                    </div>
                );
                itemCount++;
            });

            // Push the current group's items as a new column
            columns.push(
                <div key={`${groupIndex}-column-${columnIndex}`} style={{ marginRight: '20px' }}>
                    {currentColumnItems}
                </div>
            );
            columnIndex++;
        });

        return (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                {columns}
            </div>
        );
    };




    return (
        <Paper
            sx={{                
                padding: "20px",
                maxWidth: "1250px",
                display: "grid",
            }}
            ref={props.prevStepRef}
        >
            <CollectionTypeRadioButtons  
                collectionUId={null}
                collectionType={collectionType}
                handleCollectionTypeChange={handleCollectionTypeChange}
            />

            <RadioGroup
                defaultValue={selectedObjectUId}
                value={selectedObjectUId}
                onChange={(event) => handleObjectSelection(event)}
            >
                {renderData(collectionObjects, 9)}
            </RadioGroup>

        </Paper>
    );
};

export default SelectObject;

export const CollectionTypeRadioButtons =(props) =>{

    const {collectionUId, collectionType, handleCollectionTypeChange } = props;

    return (
        <>
            {!collectionUId &&      
                <div className="make-collection-div">
                    <Typography sx={{marginRight: "20px", fontWeight: "700", color: "#16365f !important" }} >Make Collection From</Typography>

                    <RadioGroup sx={{display: "contents"}} value={collectionType} onChange={handleCollectionTypeChange}>
                        <FormControlLabel
                            value={AppEnum.CollectionType.FromScratch}
                            control={<Radio sx={{ color: "#018786", "&.Mui-checked": { color: "#018786" } }} />}
                            label="Scratch"
                            sx={{ color: "#6B859E" }}
                        />
                        <FormControlLabel
                            value={AppEnum.CollectionType.FromChildTemplate}
                            control={<Radio sx={{ color: "#018786", "&.Mui-checked": { color: "#018786" } }} />}
                            label="Template"
                            sx={{ color: "#6B859E" }}
                        />
                    </RadioGroup>
                </div>
            }
        </>
    )
}